<template>
  <div>
    <Header page="my_page"/>
    <b-container class="mt-5">
      <b-row>
        <b-col cols="12" lg="3" class="mypage__sidebar mypage__sidebar-mb">
          <SidebarMypage myPage="setting"/>
        </b-col>
        <b-col cols="12" lg="9" class="pl-70">
          <div class="notification">
            <div class="w-100">
              <div class="w-100 d-flex justify-content-between noti-box">
                <div>新規ファイルアップロード</div>
                <label class="switch">
                  <input type="checkbox" v-bind:checked="notification_create" v-on:change="updateStatusNotificationCreate">
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="w-100 d-flex justify-content-between align-items-center noti-box">
                <div>ファイル更新</div>
                <label class="switch">
                  <input type="checkbox" v-bind:checked="notification_update" v-on:change="updateStatusNotificationUpdate">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SidebarMypage from '@/views/Employee/MyPage/SidebarMypage'
import {mapState} from 'vuex'
import Header from '@/components/share/Header'
import { STATUS_NOTIFICATION, STATUS } from '../../../utils/constant'
export default {
  name: 'SettingNotification',
  components: {
    Header,
    SidebarMypage
  },
  data () {
    return {
      'notification_create': true,
      'notification_update': true
    }
  },
  methods: {
    updateStatusNotificationCreate () {
      const formData = new FormData()
      this.notification_create = !this.notification_create
      if (this.notification_create) {
        if (this.notification_update) {
          formData.append('notification_status', STATUS_NOTIFICATION.RECEIVE_ALL)
        } else {
          formData.append('notification_status', STATUS_NOTIFICATION.RECEIVE_CREATED)
        }
      } else {
        if (!this.notification_update) {
          formData.append('notification_status', STATUS_NOTIFICATION.NOT_RECEIVE)
        } else {
          formData.append('notification_status', STATUS_NOTIFICATION.RECEIVE_UPDATED)
        }
      }
      formData.append('_method', 'put')
      this.$store.dispatch('allAuth/editProfileEmployee', formData)
    },
    updateStatusNotificationUpdate () {
      const formData = new FormData()
      this.notification_update = !this.notification_update
      if (this.notification_update) {
        if (this.notification_create) {
          formData.append('notification_status', STATUS_NOTIFICATION.RECEIVE_ALL)
        } else {
          formData.append('notification_status', STATUS_NOTIFICATION.RECEIVE_UPDATED)
        }
      } else {
        if (!this.notification_create) {
          formData.append('notification_status', STATUS_NOTIFICATION.NOT_RECEIVE)
        } else {
          formData.append('notification_status', STATUS_NOTIFICATION.RECEIVE_CREATED)
        }
      }
      formData.append('_method', 'put')
      this.$store.dispatch('allAuth/editProfileEmployee', formData)
    },
    checkStatusNotificaton () {
      var status = this.user.notification_status
      switch (status) {
        case STATUS_NOTIFICATION.NOT_RECEIVE:
          this.notification_create = false
          this.notification_update = false
          break
        case STATUS_NOTIFICATION.RECEIVE_CREATED:
          this.notification_create = true
          this.notification_update = false
          break
        case STATUS_NOTIFICATION.RECEIVE_UPDATED:
          this.notification_create = false
          this.notification_update = true
          break
        case STATUS.RECEIVE_ALL:
          this.notification_create = true
          this.notification_update = true
          break
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.allAuth.user
    })
  },
  watch: {
    user () {
      this.checkStatusNotificaton()
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/MyPage/SettingNotification.vue